module.exports = __webpack_public_path__ + "img/logo.954e6161.png";